import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { CostAnalysisAccountDetail } from './costanalysisaccountdetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class CostAnalysisAccountService {
    private _CostAccounServiceReportUrl = CONFIGURATION.baseServiceUrl + 'accountnumbercostanalysisservice/';
    constructor(private _http: Http) { }

    getAccountNumber(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostAccounServiceReportUrl + 'getAccountNumber', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getsource(data:any){
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostAccounServiceReportUrl + 'getsource', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getAvgCount(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostAccounServiceReportUrl + 'getAverageCostCount', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getCompanyNameByAccount(accountNumber: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostAccounServiceReportUrl + 'getCompanyByAccountNumber?AccountNumber=' + accountNumber,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getProductionName(accnumber: any,companyname:any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostAccounServiceReportUrl + 'getProductionByAccountNumberAndCompany?AccountNumber=' +
        accnumber + '&CompanyName=' + companyname,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    // getAccountcost(filterCriteria: any): Observable<CostAnalysisAccountDetail[]> {
    //     const headers = new Headers();
    //     headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    //     headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    //     const fileName = 'getAccountCostAnalysisReportData?AccountNumber=' + filterCriteria.selectedAccountName
    //         + '&CompanyName=' + filterCriteria.selectedCompany + '&ProductionName=' + filterCriteria.selectedProduction +
    //         '&StartDate=' + filterCriteria.selectedStartDate +
    //         '&EndDate=' + filterCriteria.selectedEndDate;
    //     return this._http.get(this._CostAccounServiceReportUrl + fileName, { headers: headers })
    //         .map((response: Response) => <CostAnalysisAccountDetail[]>response.json())
    //         .catch(this.handleError);
    // }

    getAccountcost(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostAccounServiceReportUrl + 'v2/getAccountCostAnalysisReportData', data, { headers: headers })
        .map((response: any) => response.json())
        .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any) {
        const fileName = 'excel-download?StartDate=' + filterCriteria.selectedStartDate
            + '&EndDate=' + filterCriteria.selectedEndDate + '&AccountNumber=' + filterCriteria.selectedAccountName +
            '&CompanyName=' + filterCriteria.selectedCompany + '&ProductionName=' + filterCriteria.selectedProduction + '&SourceName=' + filterCriteria.selectedSource;
        const url = this._CostAccounServiceReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })

    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }
}



// WEBPACK FOOTER //
// ./src/app/costanalysisaccount/costanalysisaccount.service.ts